import * as React from 'react';
import { useRouter } from 'next/router';
import { ListItem, ListItemButton, Box, Collapse } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useDevice, useFavoriteDashboards } from '@hooks';

import { MenuItemLink } from '../MenuItemLink';
import styles from './menuFavoriteItem.styles';

const MenuFavoriteItem = ({ isExpanded, route, onCloseMenu }) => {
  const { pathname } = useRouter();

  const { favoriteDashboards, toggleDashboard } = useFavoriteDashboards();
  const { isMobile, isTablet } = useDevice();

  const handleClick = () => {
    if (isMobile || isTablet) onCloseMenu();
  };

  const isSelected =
    !!route.url &&
    route.url !== '/' &&
    (pathname === route.url || pathname.startsWith(`${route.url}/`));

  const idx = favoriteDashboards?.findIndex(
    (favRoute) => favRoute.url === route.url
  );

  const isFirst = idx === 0;

  const isLast = idx === favoriteDashboards.length - 1;

  const handleToggleDashboard = (e) => {
    e.preventDefault();

    toggleDashboard(route.url);
  };

  return (
    <Collapse
      in={isExpanded}
      timeout="auto"
      unmountOnExit
      aria-expanded={isExpanded}
    >
      <Box
        sx={styles.submenuFavorite}
        role="menu"
        aria-label={`${route.key}-favorite-submenu`}
      >
        <ListItem key={route.key} disablePadding>
          <ListItemButton
            component={route.url ? MenuItemLink : Box}
            href={route.url || undefined}
            onClick={handleClick}
            selected={isSelected}
            sx={{
              ...styles.subMenuFavoriteItem(isFirst, isLast),
              pointerEvents: 'auto',
            }}
            role="menuitem"
            aria-disabled={!route.url}
          >
            <Box sx={styles.subMenuFavoriteItemInnerWrapper}>
              <Box>
                <Box sx={styles.dummyMarginElement} />
                <Box sx={styles.title}>{route.title}</Box>
              </Box>
              <CloseIcon
                sx={styles.removeButton}
                onClick={(e) => handleToggleDashboard(e)}
              />
            </Box>
          </ListItemButton>
        </ListItem>
      </Box>
    </Collapse>
  );
};

export default MenuFavoriteItem;
